import PropTypes from "prop-types";

export default function ReportSubsection({ children }) {
  return (
    <div
      style={{
        breakInside: "avoid",
        marginBottom: "50px",
        textAlign: "center",
      }}
    >
      {children}
    </div>
  );
}

ReportSubsection.propTypes = {
  children: PropTypes.node.isRequired,
};
